import SearchBlock from "./search";

export default SearchBlock;